import sum from 'lodash/sum'
import * as Redux from 'redux'
import * as App from '../../../app'
import * as DateSelector from '../../../components/date-selector';
import * as IsActive from '../../../components/is_active'
import * as Pager from '../../../components/pager'
import * as Sortable from '../../../components/sortable'
import * as Request from '../../../request'
import * as Router from '../../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

type AllActions = Redux.Action &
                  Request.SuccessAction &
                  Actions.SelectDateAction &
                  DateSelector.DatedInformationAction &
                  IsActive.FilterActionObject &
                  Sortable.SortAction &
                  Types.SelectDateAction &
                  App.UrlParsedAction<{selectedDate: Types.SelectedDate}> &
                  Router.OnEnterAction<{dateSelect: Types.SelectedDate}>

const noData: Types.Counts = {
  total: 0,
  unique: 0,
}
const emptyStatsState: Types.StatsState = {
  clicks: noData,
  opens: noData,
  sends: 0,
}

export const viewReducer = (sourceReducer: any) =>
  (state: Types.ViewState = emptyViewState, action: AllActions) => {
  const sourceState = sourceReducer(state, action)
  switch (action.type) {
    case Request.requestConstant(Constants.RESUBMIT_ISSUE):
      return {
        ...sourceState,
        isLoading: true,
      }
    case Request.successConstant(Constants.RESUBMIT_ISSUE):
      return {
        ...sourceState,
        isLoading: false,
      }
    case IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT):
      return {
        ...sourceState,
        dateSelect: action.filter,
      }
    case App.URL_PARSED:
      return {
        ...state,
        selectedDate: action.params.selectedDate || state.selectedDate,
      }
    case Constants.UPDATE_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.date,
      }
    case Router.ON_ENTER:
      switch (action.urlParams.dateSelect) {
        case Constants.DATE_SELECT_YESTERDAY_MODE:
          return {
            ...state,
            dateSelect: Constants.DATE_SELECT_YESTERDAY,
          };
        case Constants.DATE_SELECT_LASTWEEK_MODE:
          return {
            ...state,
            dateSelect: Constants.DATE_SELECT_LASTWEEK,
          };
        case Constants.DATE_SELECT_CUSTOM_MODE:
          return {
            ...state,
            dateSelect: Constants.DATE_SELECT_CUSTOM,
          };
        default:
          return {
            ...state,
            dateSelect: Constants.DATE_SELECT_TODAY,
          };
      }
    default:
      return sourceState
  }
}

const issuesReducer = (state: Types.IssueState = [], action: AllActions) => {
  switch (action.type) {
    case App.SELECT_COMMUNITY:
    case Request.requestConstant(Constants.FETCH_TODAY_ISSUES):
    case Request.errorConstant(Constants.FETCH_TODAY_ISSUES):
      return []
    case Request.successConstant(Constants.FETCH_TODAY_ISSUES):
      return action.payload.response.map((p: any) => Utils.toIssue(p))
    default:
      return state
  }
}

const statsReducer = (state: Types.StatsState = emptyStatsState, action: AllActions) => {
  switch (action.type) {
    case App.SELECT_COMMUNITY:
    case Request.requestConstant(Constants.FETCH_TODAY_ISSUES):
    case Request.errorConstant(Constants.FETCH_TODAY_ISSUES):
    case Request.errorConstant(Constants.FETCH_TODAY_ACTIONS):
      return emptyStatsState
    case Request.successConstant(Constants.FETCH_TODAY_ACTIONS):
      return {
        ...state,
        ...Utils.parseSummaryStats(action.payload.response),
      }
    case Request.successConstant(Constants.FETCH_TODAY_ISSUES):
      const issues = action.payload.response.map((p: any) => Utils.toIssue(p))
      return {
        ...state,
        sends: sum(issues.map((i: Types.Issue) => i.stats.sends)),
      }
    default:
      return state
  }
}

const emptyViewState: Types.ViewState = {
  dateSelect: Constants.DATE_SELECT_TODAY,
  dateValue: null,
  isLoading: false,
  selectedDate: null,
}

const emptyActionsState: Types.ActionsState = {
  actions: [],
  hourly: [],
}

const actionsReducer = (state: Types.ActionsState = emptyActionsState, action: AllActions) => {
  switch (action.type) {
    case App.SELECT_COMMUNITY:
    case Request.requestConstant(Constants.FETCH_TODAY_ACTIONS):
    case Request.requestConstant(Constants.FETCH_TODAY_ISSUES):
    case Request.errorConstant(Constants.FETCH_TODAY_ACTIONS):
      return emptyActionsState
    case Request.successConstant(Constants.FETCH_TODAY_ACTIONS):
      return {
        actions: Utils.parseActions(action.payload.response),
        hourly: Utils.parseHourlyActions(action.payload.response),
      }
    default:
      return state
  }
}

const normalizeSubjectLineResponse: Sortable.TypeNormalizer<Types.SubjectLine> =
  (payload: any): Sortable.SortableData<Types.SubjectLine> => {
  return payload.map((p: any) => Utils.toSubjectLine(p))
}

const subjectLinesPageState: Pager.PageState = {
  pageNumber: 1,
  skip: 0,
  take: 5,
}

const subjectLinesReducerEvent: Sortable.ReducerEvent<Types.SubjectLine> = {
  clearEvent: Request.requestConstant(Constants.FETCH_TODAY_ISSUES),
  defaultSort: {field: 'sends', dir: 'desc'},
  normalizer: normalizeSubjectLineResponse,
  requestEvent: Constants.FETCH_TODAY_SUBJECT_LINES,
}

const reducerEvent: Sortable.ReducerEvent<Types.IssueCounts> = {
  defaultSort: {field: 'identifier', dir: 'asc'},
  requestEvent: Constants.FETCH_TODAY_ISSUES,
}

export const reducer = Redux.combineReducers({
  actions: actionsReducer,
  data: Sortable.stateReducer(reducerEvent),
  issues: issuesReducer,
  stats: statsReducer,
  subjectLines: Redux.combineReducers({
    data: Sortable.stateReducer(subjectLinesReducerEvent),
    page: Pager.createReducer(Constants.FETCH_TODAY_SUBJECT_LINES, subjectLinesPageState),
    view: Sortable.viewReducer(subjectLinesReducerEvent),
  }),
  view: viewReducer(Sortable.viewReducer(reducerEvent)),
})



// WEBPACK FOOTER //
// ./src/pages/reports/today/reducer.ts